import { Controller, useFormContext } from 'react-hook-form'
import { Field } from '../Field'
import { SectionStyled } from '../onboardingStyles'
import { MAX_SPECIALTIES, SpecialtyChips } from '../SpecialtyChips'
import { ICoachProfileFormValues } from '../types'

interface ISpecialtiesSection {
  onChange: () => void
}

export const SpecialtiesSection = ({ onChange: markUnsaved }: ISpecialtiesSection) => {
  const {
    control,
    watch,
    formState: { errors }
  } = useFormContext<ICoachProfileFormValues>()

  const count = watch('specialties').length

  return (
    <SectionStyled id="section-specialties">
      <div className="section-head">
        <div className="heading-block">
          <span className="num" aria-hidden="true">
            04
          </span>
          <div>
            <h2>Specialties</h2>
            <div className="blurb">Pick 1–5. Clients filter coaches by these.</div>
          </div>
        </div>
        <span className={count >= MAX_SPECIALTIES ? 'count warn' : 'count'} aria-live="polite">
          {count} / {MAX_SPECIALTIES} selected
        </span>
      </div>

      <Field error={errors.specialties?.message as string | undefined}>
        <Controller
          control={control}
          name="specialties"
          rules={{
            validate: (value) =>
              value.length >= 1 && value.length <= MAX_SPECIALTIES
                ? undefined
                : 'Select between 1 and 5 specialties.'
          }}
          render={({ field: { onChange, value } }) => (
            <SpecialtyChips
              value={value}
              onChange={(next) => {
                onChange(next)
                markUnsaved()
              }}
            />
          )}
        />
      </Field>
    </SectionStyled>
  )
}
